var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReCampaignFrequency = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.99991C14.6569 6.99991 16 8.34305 16 9.99991V17.9999C16 19.6568 14.6569 20.9999 13 20.9999H3C1.34315 20.9999 0 19.6568 0 17.9999V9.99991C1.28851e-07 8.34305 1.34315 6.99991 3 6.99991H13ZM12.5996 11.5497C12.351 11.2186 11.8811 11.1519 11.5498 11.4003L9.34961 13.0497C8.54967 13.6496 7.45033 13.6496 6.65039 13.0497L4.4502 11.4003C4.11894 11.1519 3.64899 11.2186 3.40039 11.5497C3.15195 11.881 3.21872 12.3509 3.5498 12.5995L5.75 14.2499C7.08333 15.2499 8.91667 15.2499 10.25 14.2499L12.4502 12.5995C12.7813 12.3509 12.8481 11.881 12.5996 11.5497ZM17.4697 0.469632C17.7626 0.176764 18.2374 0.176814 18.5303 0.469632L19.8232 1.7626C20.5067 2.44602 20.5067 3.55379 19.8232 4.23721L18.5303 5.53018C18.2374 5.823 17.7626 5.82305 17.4697 5.53018C17.1769 5.2373 17.1769 4.76251 17.4697 4.46963L18.1895 3.74991H14C13.5859 3.74982 13.25 3.41407 13.25 2.99991C13.25 2.58574 13.5859 2.24999 14 2.24991H18.1895L17.4697 1.53018C17.1769 1.2373 17.1769 0.762506 17.4697 0.469632Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReCampaignFrequency);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_Campaign_frequency.ff78c2095dea121fc3b0257e8bbd7d70.svg";